module.exports.initialState = (id, master_id = undefined) => {
  var state = {
    id: id,
    master_id: master_id,
    master_email: undefined,
    master_account: undefined,
    countries: undefined,
    country_code: undefined,
    country: undefined,
    accounts: undefined,
    cities: [],
    name: undefined,
    former_name: undefined,
    pccwglobal_insight_company_code: undefined,
    pccwglobal_signed_bdm_name: undefined,
    pccwglobal_signed_bdm_id: undefined,
    address_country: undefined,
    address_city: undefined,
    address_line_1: undefined,
    address_line_2: undefined,
    address_line_3: undefined,
    address_postcode: undefined,
    business_jurisdiction: undefined,
    business_registration_number: undefined,
    vat_number: undefined,
    commercial_contact_name: undefined,
    commercial_contact_phone: undefined,
    commercial_contact_email: undefined,
    financial_contact_name: undefined,
    financial_contact_phone: undefined,
    financial_contact_email: undefined,
    fault_reporting_contact_name: undefined,
    fault_reporting_contact_phone: undefined,
    fault_reporting_contact_email: undefined,
    billing_details: undefined,
    bank_information: undefined,
    website: undefined,
    other_information: undefined,
    company: undefined,
    citysearch: false,
    submitted: false,
    filters: { orderby: 'account_type_id', asc: true, customer_id: id },
  }
  return state;
}

module.exports.submitValues = (actualState) => {
  return {
    name: actualState.name,
    master_id: actualState.master_id,
    master_email: actualState.master_email,
    former_name: actualState.former_name,
    pccwglobal_insight_company_code: actualState.pccwglobal_insight_company_code,
    pccwglobal_signed_bdm_name: actualState.pccwglobal_signed_bdm_name,
    pccwglobal_signed_bdm_id: actualState.pccwglobal_signed_bdm_id,
    address_country: actualState.address_country,
    address_city: actualState.address_city,
    address_line_1: actualState.address_line_1,
    address_line_2: actualState.address_line_2,
    address_line_3: actualState.address_line_3,
    address_postcode: actualState.address_postcode,
    business_jurisdiction: actualState.business_jurisdiction,
    business_registration_number: actualState.business_registration_number,
    vat_number: actualState.vat_number,
    commercial_contact_name: actualState.commercial_contact_name,
    commercial_contact_phone: actualState.commercial_contact_phone,
    commercial_contact_email: actualState.commercial_contact_email,
    financial_contact_name: actualState.financial_contact_name,
    financial_contact_phone: actualState.financial_contact_phone,
    financial_contact_email: actualState.financial_contact_email,
    fault_reporting_contact_name: actualState.fault_reporting_contact_name,
    fault_reporting_contact_phone: actualState.fault_reporting_contact_phone,
    fault_reporting_contact_email: actualState.fault_reporting_contact_email,
    billing_details: actualState.billing_details,
    bank_information: actualState.bank_information,
    website: actualState.website,
    other_information: actualState.other_information,
  }
}


module.exports.companyForm = (phrasebook, actualState, selects, new_customer = false) => {
  var inputs = [
    { label: phrasebook.profile.customer_name, type: "text", placeholder: actualState.name, id: "name", name: "name", value: actualState.name, required: true },
    { label: phrasebook.profile.company_alias, type: "text", placeholder: actualState.former_name, id: "former_name", name: "former_name", value: actualState.former_name },
    {
      label: phrasebook.profile.pccwglobal_insight_company_code,
      type: "text", placeholder: actualState.pccwglobal_insight_company_code,
      id: "pccwglobal_insight_company_code",
      name: "pccwglobal_insight_company_code",
      value: actualState.pccwglobal_insight_company_code
    },
    {
      label: phrasebook.references.pccwglobal_signed_bdm_name,
      type: "text",
      id: "pccwglobal_signed_bdm_name",
      tooltip: 'BDM FULL NAME',
      name: "pccwglobal_signed_bdm_name",
      value: actualState.pccwglobal_signed_bdm_name,
    },
    {
      label: phrasebook.references.pccwglobal_signed_bdm_id,
      type: "text",
      id: "pccwglobal_signed_bdm_id",
      tooltip: 'BDM ID',
      name: "pccwglobal_signed_bdm_id",
      value: actualState.pccwglobal_signed_bdm_id
    },
    { label: phrasebook.profile.registred_address, type: "subsection" },
    {
      label: phrasebook.profile.address_country,
      type: "select",
      id: "address_country",
      tooltip: phrasebook.tooltip.jurisdiction,
      name: "address_country",
      options: selects.countries,
      selected: actualState.address_country,
      empty_option: true
    },
    {
      label: phrasebook.profile.address_city,
      type: "text",
      id: "address_city",
      tooltip: 'Cities',
      name: "address_city",
      value: actualState.address_city,
      placeholder: actualState.address_city,
    },

    { label: phrasebook.profile.address_line_1, type: "text", placeholder: actualState.address_line_1, id: "address_line_1", name: "address_line_1", value: actualState.address_line_1 },
    { label: phrasebook.profile.address_line_2, type: "text", placeholder: actualState.address_line_2, id: "address_line_2", name: "address_line_2", value: actualState.address_line_2 },
    { label: phrasebook.profile.address_line_3, type: "text", placeholder: actualState.address_line_3, id: "address_line_3", name: "address_line_3", value: actualState.address_line_3 },
    { label: phrasebook.profile.address_postcode, type: "text", placeholder: actualState.address_postcode, id: "address_postcode", name: "address_postcode", value: actualState.address_postcode },
    { label: phrasebook.profile.business_details, type: "subsection" },
    {
      label: phrasebook.profile.business_jurisdiction,
      type: "select",
      id: "business_jurisdiction",
      tooltip: phrasebook.tooltip.jurisdiction,
      name: "business_jurisdiction",
      options: selects.countries,
      value: actualState.business_jurisdiction,
      empty_option: true
    },
    { label: phrasebook.profile.business_registration_number, type: "text", placeholder: actualState.business_registration_number, id: "business_registration_number", name: "business_registration_number", value: actualState.business_registration_number },
    { label: phrasebook.profile.vat_number, type: "text", placeholder: actualState.vat_number, id: "vat_number", name: "vat_number", value: actualState.vat_number },
    { label: phrasebook.headerlinks.contacts, type: "subsection" },

    { label: phrasebook.profile.commercial_contact_name, type: "text", placeholder: actualState.commercial_contact_name, id: "commercial_contact_name", name: "commercial_contact_name", value: actualState.commercial_contact_name },
    { label: phrasebook.profile.commercial_contact_phone, type: "text", placeholder: actualState.commercial_contact_phone, id: "commercial_contact_phone", name: "commercial_contact_phone", value: actualState.commercial_contact_phone },
    { label: phrasebook.profile.commercial_contact_email, type: "text", placeholder: actualState.commercial_contact_email, id: "commercial_contact_email", name: "commercial_contact_email", value: actualState.commercial_contact_email },
    { label: phrasebook.profile.financial_contact_name, type: "text", placeholder: actualState.financial_contact_name, id: "financial_contact_name", name: "financial_contact_name", value: actualState.financial_contact_name },
    { label: phrasebook.profile.financial_contact_phone, type: "text", placeholder: actualState.financial_contact_phone, id: "financial_contact_phone", name: "financial_contact_phone", value: actualState.financial_contact_phone },
    { label: phrasebook.profile.financial_contact_email, type: "text", placeholder: actualState.financial_contact_email, id: "financial_contact_email", name: "financial_contact_email", value: actualState.financial_contact_email },
    { label: phrasebook.profile.fault_reporting_contact_name, type: "text", placeholder: actualState.fault_reporting_contact_name, id: "fault_reporting_contact_name", name: "fault_reporting_contact_name", value: actualState.fault_reporting_contact_name },
    { label: phrasebook.profile.fault_reporting_contact_phone, type: "text", placeholder: actualState.fault_reporting_contact_phone, id: "fault_reporting_contact_phone", name: "fault_reporting_contact_phone", value: actualState.fault_reporting_contact_phone },
    { label: phrasebook.profile.fault_reporting_contact_email, type: "text", placeholder: actualState.fault_reporting_contact_email, id: "fault_reporting_contact_email", name: "fault_reporting_contact_email", value: actualState.fault_reporting_contact_email },
    {
      label: phrasebook.profile.customer_billing_details,
      type: "text",
      placeholder: actualState.billing_details,
      id: "billing_details",
      name: "billing_details",
      value: actualState.billing_details
    },
    {
      label: phrasebook.profile.customer_bank_information,
      type: "text",
      placeholder: actualState.bank_information,
      id: "bank_information",
      name: "bank_information",
      value: actualState.bank_information
    },
    { label: phrasebook.common.website, type: "text", placeholder: actualState.website, id: "website", name: "website", value: actualState.website },
    {
      label: phrasebook.profile.customer_other_information,
      type: "textarea",
      placeholder: actualState.other_information,
      id: "other_information",
      name: "other_information",
      value: actualState.other_information
    }
  ]
  if (actualState.master_account) inputs.unshift({ label: phrasebook.profile.master_information, type: "text", placeholder: actualState.master_account.email, id: "master_account", name: "master_account", value: actualState.master_account.email, disabled: true },)
  else if (new_customer == false && selects.accounts) {
    inputs.unshift({
      label: phrasebook.profile.master_information,
      type: "select",
      id: "master_id",
      tooltip: phrasebook.tooltip.master,
      name: "master_id",
      options: selects.accounts,
      selected: actualState.master_id,
      empty_option: true
    })
  }

  return inputs;
}
